import React from 'react';
import styles from './HeaderPricing.module.css';
import IconLogo from '../../../shared/ui/icons/IconLogo';
import UserProfileButton from '../../../shared/ui/user-profile-button/UserProfileButton';
import LogoComponent from '../../../shared/ui/logo/LogoComponent';

type HeaderPricingProps = {
    className?: string;
};

const HeaderPricing: React.FC<HeaderPricingProps> = ({ className }) => {
    return (
        <header className={`${styles.container} ${className || ''}`}>
            <LogoComponent />
            <UserProfileButton />
        </header>
    );
};

export default HeaderPricing;
